import React from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles';
import defaultTheme from './DefaultTheme';
export default (function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b;
    return (React.createElement(StylesProvider, { injectFirst: true },
        React.createElement(StyledEngineProvider, { injectFirst: true },
            React.createElement(ThemeProvider, { children: children, theme: theme }))));
});
